module.exports = {"510113001":"红阳街道","510113002":"大弯街道","510113102":"弥牟镇","510113103":"大同镇","510113104":"城厢镇","510113105":"祥福镇","510113106":"姚渡镇","510113108":"清泉镇","510113110":"龙王镇","510113111":"福洪镇","510113203":"人和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510113.json
// module id = 2259
// module chunks = 0